<template>
  <div class="score-card">
    <div class="score-num" :class="'tone-' + color">
      <template v-if="value != null">{{ value }}<span class="denom">/{{ denom }}</span></template>
      <template v-else>-</template>
    </div>
    <div class="score-info">
      <div class="lbl">{{ label }}</div>
      <div class="meta" v-html="meta"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AiwV2ScoreCard",
  props: {
    label: { type: String, default: "" },
    value: { default: null },
    denom: { type: Number, default: 100 },
    meta: { type: String, default: "" },
    color: { type: String, default: "amber" }, // amber | green | orange
  },
};
</script>

<style scoped>
.score-card { background: #fff; border: 1px solid var(--border, #e4e4e4); border-radius: var(--r-lg, 10px); padding: 18px 22px; display: flex; align-items: center; gap: 18px; }
/* Color modifiers are prefixed `tone-` to avoid Vuetify's global `.green` /
   `.amber` / `.orange` color utilities, which force a background-color. */
.score-num { font-size: 40px; font-weight: 700; color: var(--pop-amber, #aa993b); line-height: 1; }
.score-num.tone-green { color: var(--pop-green, #25a97a); }
.score-num.tone-orange { color: var(--pop-orange, #ff5700); }
.score-num .denom { font-size: 16px; color: var(--text-3, #6b7b7e); font-weight: 500; }
.score-info .lbl { font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: .05em; color: var(--text-3, #6b7b7e); margin-bottom: 2px; }
.score-info .meta { font-size: 12.5px; color: var(--text-2, #014751); }
.score-info .meta :deep(strong) { color: var(--text, #052e33); font-weight: 600; }
</style>
